import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {PaymentsRedirectApplication} from "../../services/casinofied/app-launcher/apps/payments-redirect/payments-redirect.application";
import {CyClass} from "../../../common/cy-classes";
import {PaymentRedirectFocusTitleBox} from "./boxes/payment-redirect-focus-title/payment-redirect-focus-title.box";
import {PaymentRedirectFocusBox} from "./boxes/payment-redirect-focus-container/payment-redirect-focus.box";
import { ModalDialogActionsComponent } from "../modal-dialog/modal-dialog-actions.component";

interface PaymentsRedirectFocusComponentProps {
    redirectApp: PaymentsRedirectApplication;
}

export class PaymentsRedirectFocusComponent extends OrbitComponent<PaymentsRedirectFocusComponentProps> {

    private _renderButtonContainer(): React.ReactNode {
        return (
            <ModalDialogActionsComponent primaryAction={{
                text: this.services.translation.translate("PAYMENTS_REDIRECT_FOCUS_CTA"),
                onClick: ()=>{}
            }} />
        );
    }

    render() {
        return (
            <PaymentRedirectFocusBox
                className={CyClass('cy-payments-redirect-focus')}
                onClick={() => this.props.redirectApp.focus()}
            >
                <PaymentRedirectFocusTitleBox>
                    {this.services.translation.translate("PAYMENTS_REDIRECT_FOCUS_TEXT", {mftName: this.props.redirectApp.mftName})}
                </PaymentRedirectFocusTitleBox>
                {this._renderButtonContainer()}
            </PaymentRedirectFocusBox>
        );
    }
}
